import { createReducer, on } from '@ngrx/store';
import { ReviewTargetsActions, RouterActions, AppActions } from '@actions/index'
import { ReviewTargetModel } from '@models/index'
import { emptyReviewTargetModel } from '@utilities/data-utils';

export interface State {
    reviewTargets: ReviewTargetModel[];
    selectedReviewTarget: ReviewTargetModel;
    total: number;
    enableAll: boolean;
    error: string;
    reviewSourcesByQuery: ReviewTargetModel[];
    locationReviewTargetWithErrors: boolean;
    reviewTargetToIntegrate: string;
    showReviewTargetLocationFormAfterRedirect: boolean;
    uiReviewTargetd: ReviewTargetModel[];
}

const initialState: State = {
    reviewTargets: [],
    selectedReviewTarget: emptyReviewTargetModel(),
    enableAll: true,
    total: 0,
    error: '',
    reviewSourcesByQuery: [],
    locationReviewTargetWithErrors: false,
    reviewTargetToIntegrate: '',
    showReviewTargetLocationFormAfterRedirect: false,
    uiReviewTargetd: []
};

export const reducer = createReducer(
    initialState,
    on(ReviewTargetsActions.searchAllReviewTargets, (state) => ({ ...state, reviewTargets: [], total: 0 })),
    on(ReviewTargetsActions.searchReviewTargetsSuccess, (state, { data, total }) => ({
        ...state,
        reviewTargets: data,
        total,
        enableAll: data.find((item) => item.enable === false) ? false : true
    })),
    on(ReviewTargetsActions.searchReviewSourcesQuerySuccess, (state, { data }) => ({ ...state, reviewSourcesByQuery: data })),
    on(ReviewTargetsActions.searchAllReviewTargetsByLocationSuccess, (state, { reviewTargets }) => ({ ...state, reviewTargets: reviewTargets })),
    on(ReviewTargetsActions.saveReviewTargetSuccess, (state, { reviewTarget }) => {
        return ({ 
        ...state, 
        enableAll: state.reviewTargets.find((item) => item.enable === false || reviewTarget.enable === false) ? false : true, 
        reviewTargets: state.reviewTargets
            .map(item => item.id == reviewTarget.id ? reviewTarget : item)
            .map(item => ({
                ...item,
                priority: state.uiReviewTargetd.find(uiItem=>item.id === uiItem.id).priority
            }))
            .sort((item1, item2) => item1.priority > item2.priority ? 1 : -1)
            .map((item, index) => ({
                ...item,
                isReviewTarget: item.isReviewTarget && index > 2 ? false : item.isReviewTarget
            }))
    })}),
    on(ReviewTargetsActions.disableOrEnabledSuccess, (state, { reviewTarget }) => {
        return ({ 
        ...state, 
        enableAll: state.reviewTargets.find((item) => item.enable === false || reviewTarget.enable === false) ? false : true, 
        reviewTargets: state.reviewTargets
            .map(item => item.id == reviewTarget.id ? reviewTarget : item)
    })}),
    // on(ReviewTargetsActions.addReviewSourceToLocationSuccess, (state, { reviewSource }) => ({ ...state, reviewTargets: [...state.reviewTargets, reviewSource] })),
    on(ReviewTargetsActions.deleteReviewTargetSuccess, (state, { reviewTargetId }) => ({ ...state, reviewTargets: state.reviewTargets.filter((reviewTarget) => reviewTarget.id !== reviewTargetId)})),
    on(ReviewTargetsActions.setSelectedReviewTarget, (state, { reviewTarget }) => ({ ...state, selectedReviewTarget: reviewTarget })),
    on(ReviewTargetsActions.reviewTargetError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
    on(AppActions.clearState, (state) => {
        return ({ ...state, 
            reviewTargets: [],
            total: 0,
            reviewSourcesByQuery: [],
        })}),
    on(ReviewTargetsActions.searchLocationReviewTargetWithErrorsSuccses, (state, {locationReviewTargetWithErrors}) => ({ ...state, locationReviewTargetWithErrors: locationReviewTargetWithErrors })),
    on(ReviewTargetsActions.setReviewTargetToIntegrate, (state, {reviewTargetId}) => ({ ...state, reviewTargetToIntegrate: reviewTargetId })),
    on(ReviewTargetsActions.setShowRevieTargetLocationFormAfterRedirect, (state, {showForm}) => ({ ...state, showReviewTargetLocationFormAfterRedirect: showForm })),
    on(ReviewTargetsActions.setUIReviewTargetList, (state, {list}) => ({ ...state, uiReviewTargetd: list }))
);

export const getReviewTargets = (state: State) => state.reviewTargets;
export const getUIReviewTargets = (state: State) => state.uiReviewTargetd;
export const getEnableAll = (state: State) => state.enableAll;
export const getSelectedReviewTarget = (state: State) => state.selectedReviewTarget;
export const getTotal = (state: State) => state.total;
export const getError = (state: State) => state.error;
export const getReviewSourcesByQuery = (state: State) => state.reviewSourcesByQuery;
export const getLocationReviewTargetWithErrors = (state: State) => state.locationReviewTargetWithErrors;
export const getReviewTargetToIntegrate = (state: State) => state.reviewTargetToIntegrate;
export const getShowRevieTargetLocationFormAfterRedirect = (state: State) => state.showReviewTargetLocationFormAfterRedirect;
